import { Avatar, Modal, ModalProps } from 'antd';
import { CopyableField } from '../copyable-field';
import { useTheme } from 'styled-components';

interface IPerkModalProps {
	title: string;
	percent?: number;
	logo: string;
	ctaLink: string;
	promoCode?: string;
}

export const PerkModal: React.FC<ModalProps & IPerkModalProps> = ({
	title,
	percent,
	logo,
	ctaLink,
	promoCode,
	open,
	onCancel
}) => {
	const theme = useTheme();
	return (
		<Modal
			className="ta-modal"
			title={
				<div
					className="d-flex align-items-center justify-content-between"
					style={{ color: theme.TA_BLUISH_GREY }}
				>
					<div className="d-flex align-items-center">
						<Avatar src={logo} className="me-2" />
						<span>{title}</span>
					</div>
					{percent ? (
						<span>
							<span className="me-1">{percent}%</span>
							<span style={{ fontSize: '0.9rem', fontWeight: '400' }}>Off</span>
						</span>
					) : null}
				</div>
			}
			closable={false}
			open={open}
			onCancel={onCancel}
			footer={null}
		>
			{promoCode ? (
				<>
					<p style={{ color: '#000' }}>1. Get offer by using promocode</p>
					<CopyableField className="mb-3" text={promoCode} textElement={<span>{promoCode}</span>} />
				</>
			) : (
				false
			)}

			<>
				<p style={{ color: '#000' }}>{promoCode ? '2. Use promocode here' : 'Visit this link'}</p>
				<CopyableField
					text={ctaLink}
					textElement={<span style={{ color: theme.TA_INFO, textDecoration: 'underline' }}>{ctaLink}</span>}
				/>
			</>
		</Modal>
	);
};
